var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSwift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 44,
    viewBox: "0 0 50 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8181 0.125366C52.799 14.7938 45.671 30.9123 45.671 30.9123C45.671 30.9123 51.9146 37.8215 49.4053 43.8745C49.4053 43.8745 46.8147 39.6465 42.5148 39.6465C38.3586 39.6465 35.8993 43.8745 27.5088 43.8745C8.8467 43.8745 0 28.5811 0 28.5811C16.8184 39.4558 28.3088 31.7497 28.3088 31.7497C20.7152 27.4436 4.60928 6.82211 4.60928 6.82211C18.6496 18.5438 24.7089 21.6218 24.7089 21.6218C21.0652 18.6969 10.9123 4.36278 10.9123 4.36278C19.0371 12.422 35.1868 23.6593 35.1868 23.6593C39.818 11.2408 30.8181 0.125366 30.8181 0.125366Z",
    fill: "#FF5722"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSwift);
export default __webpack_public_path__ + "static/media/icon_swift.702f2428b1db29c768e704e1553ed2e1.svg";
export { ForwardRef as ReactComponent };